import { FC } from "react";
import { Trans } from "@lingui/macro";
import { DropdownOutlined } from "src/atoms/DropDown";
import { PriceFilter } from "./PriceFilter";
import { connectRange } from "react-instantsearch-dom";

interface Props {
  filterIndex: number;
  outerRef: React.RefObject<HTMLDivElement>;
  setCurrentIndex: (index: number) => () => void;
  closeFilters: () => void;
  opened: boolean;
  min: number;
  max: number;
  currentRefinement: {
    min: number;
    max: number;
  };
  refine: ({ min, max }: { min: number; max: number }) => void;
  canRefine?: boolean;
}

const PriceConnectRange: FC<Props> = ({
  filterIndex,
  outerRef,
  setCurrentIndex,
  closeFilters,
  opened,
  min,
  max,
  currentRefinement,
  refine,
  canRefine,
}) => {
  if (min === max || !canRefine) {
    return null;
  }
  return (
    <DropdownOutlined opened={opened}>
      <DropdownOutlined.Button
        onClick={setCurrentIndex(filterIndex)}
        data-testid={`filter-price-button`}
      >
        <span>
          <Trans>Price</Trans>
        </span>
      </DropdownOutlined.Button>
      <DropdownOutlined.Items data-testid={`filter-price-list`}>
        <PriceFilter
          onClose={closeFilters}
          outerRef={outerRef}
          max={max}
          min={min}
          currentRefinement={currentRefinement}
          refine={refine}
        />
      </DropdownOutlined.Items>
    </DropdownOutlined>
  );
};

export default connectRange(PriceConnectRange);
